"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgumentType = exports.BindingItemType = exports.UNBIND_ALL = void 0;
exports.UNBIND_ALL = 'ALL';
var BindingItemType;
(function (BindingItemType) {
    BindingItemType["ItemBinding"] = "ItemBinding";
    BindingItemType["MethodBinding"] = "MethodBinding";
})(BindingItemType || (exports.BindingItemType = BindingItemType = {}));
var ArgumentType;
(function (ArgumentType) {
    ArgumentType["ProviderBinding"] = "ProviderBindingItem";
    ArgumentType["Static"] = "StaticArgItem";
})(ArgumentType || (exports.ArgumentType = ArgumentType = {}));
